export enum MeetingType {
  Congress = 'congress',
  Conference = 'conference',
  Formation = 'formation',
}
